import { getCustomApiBaseUrl } from '../modules/cloud/constant';

export const getDomain = () => {
  const customEnv = process.env.CUSTOM_API_ENV || 'development';

  switch (customEnv) {
    case 'prod':
    case 'production':
      return 'https://www.muset.ai';
    case 'dev':
    case 'development':
    default:
      return 'https://muset-web-dev.wenxiaobai.com';
  }
};
export const getAppCallbackDomain = () => {
  return getCustomApiBaseUrl();
};

export const GOOGLE_LINK = 'https://accounts.google.com/gsi/client';
export const GOOGLE_CLIENT_ID =
  '692655720779-1bs1nj0ks5uiud34mok2fih39bbpbrce.apps.googleusercontent.com';
export const GOOGLE_LOGIN_URI = `https://accounts.google.com/o/oauth2/v2/auth`;
export const GOOGLE_REDIRECT_URI = `${window.location.origin}/oauth/callback`;
export const GOOGLE_SCOPE = 'profile email';
export const GOOGLE_STATE = JSON.stringify({
  platform: 'google',
});

// export const APPLE_CLIENT_ID = 'agent.nureka.ai';
export const APPLE_CLIENT_ID = 'agent.nureka.ai';
export const APPLE_REDIRECT_URI = `${getAppCallbackDomain()}/api/v1.0/user/apple/oauth/callback`;
export const APPLE_LOGIN_URI = `https://appleid.apple.com/auth/authorize`;
export const APPLE_SCOPE = 'name email';
export const APPLE_RESPONSE_TYPE = 'code';
export const APPLE_RESPONSE_MODE = 'form_post';
export const APPLE_STATE = JSON.stringify({
  platform: 'apple',
  visitDomian: `${window.location.origin}`,
});

export const getGoogleState = (redirectUrl?: string) =>
  JSON.stringify({
    platform: 'google',
    ...(redirectUrl ? { redirectUrl } : {}),
  });

export const getAppleState = (redirectUrl?: string) =>
  JSON.stringify({
    platform: 'apple',
    visitDomian: `${window.location.origin}`,
    ...(redirectUrl ? { redirectUrl } : {}),
  });
export const LoginConfig = {
  apple: {
    clientId: APPLE_CLIENT_ID,
    redirectUri: APPLE_REDIRECT_URI,
    loginUri: APPLE_LOGIN_URI,
    scope: APPLE_SCOPE,
    response_type: APPLE_RESPONSE_TYPE,
    response_mode: APPLE_RESPONSE_MODE,
    getState: getAppleState,
  },
  google: {
    clientId: GOOGLE_CLIENT_ID,
    redirectUri: GOOGLE_REDIRECT_URI,
    loginUri: GOOGLE_LOGIN_URI,
    scope: GOOGLE_SCOPE,
    getState: getGoogleState,
    prompt: 'select_account',
    access_type: 'offline',
  },
};
